import React from 'react';
import MobileTitleNavbar from './mobile-title-navbar';
import SimpleMobileSubpageNavbar from './simple-mobile-subpage-navbar';

interface SimpleNavbarProps {
  subpage?: boolean;
  title: string;
  button?: {
    onClick: () => void;
    icon?: string;
    showAlert?: boolean;
    text?: string;
  };
}

const SimpleMobilePageNavbar = ({subpage = false, title, button}: SimpleNavbarProps) =>
  !subpage ? (
    <MobileTitleNavbar color="blue" showBackButton={false} rightButton={button}>
      {title}
    </MobileTitleNavbar>
  ) : (
    <SimpleMobileSubpageNavbar>{title}</SimpleMobileSubpageNavbar>
  );

export default SimpleMobilePageNavbar;
